import script from "./login.vue?vue&type=script&lang=ts&setup=true"
export * from "./login.vue?vue&type=script&lang=ts&setup=true"

import "./login.vue?vue&type=style&index=0&id=e00a4fa0&scoped=true&lang=scss"
import "./login.vue?vue&type=style&index=1&id=e00a4fa0&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.0_@vue+comp_e6e64a637db6d84575551e338fa99c34/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e00a4fa0"]])

export default __exports__